import React from 'react';
import SarasTabs from './SarasTabs';

//TODO support container concept for hotkeys 
//so that shortcut keys within an active container are enabled
//till then enableshort key prop is false
const SarasTabsSwitch = (props) => {
    const { switches, viewSwitcher, hotKeyPrefix, enableHotKeys, kscStartAt, showKeys } = props;

    const onGroupChange = (tabKey) => {
        viewSwitcher.onUpdateTriggerKey(tabKey);
    }

    return (
        <SarasTabs dataList={switches} onChange={onGroupChange} hotKeyPrefix={hotKeyPrefix} 
            defaultKey={viewSwitcher.triggerKey}
            enableHotKeys={enableHotKeys} kscStartAt={kscStartAt} showKeys={showKeys} 
        />
    )
}

export default SarasTabsSwitch
